import React from "react";

//function onFocus(e) {
//    console.log(e);
//}

export default function renderField({
    input,
    placeholder,
    type,
    icon,
    disabled,
    autoComplete,
    pattern,
    meta: { touched, error, warning },
    children
}) {
    const hasError = touched && error;

    icon = icon ? (
        <span className="input-group-addon">
            <i className={icon}> </i>{" "}
        </span>
    ) : "";

let field = (<input
    {...input}
    pattern={pattern}
    placeholder={placeholder}
    disabled={disabled}
    autoComplete={autoComplete} // "off" works for short forms and "chrome-off" works
    autoCorrect="off"
    spellCheck="off"
    type={type}
    //readonly
    //onfocus={onFocus}
    className={`form-control ${hasError ? "form-control-danger" : ""}`}
/>);

if (children instanceof Array && children.length > 0 && children[0].type === 'option') {
    field = (<select {...input} className={`form-control ${hasError ? "form-control-danger" : ""}`}>
        {children}
    </select>);
}


return (
    <div className={`form-group ${hasError ? "has-danger" : ""}`}>
        <div className="input-group">
            {field}
            {icon}
        </div>
        {touched &&
            ((error && <span className="form-control-feedback">{error}</span>) ||
            (warning && <span className="form-control-feedback">{warning}</span>))}
    </div>
);
}



